var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full fixed h-full login flex justify-center items-center mdmax:relative mdmax:h-screen"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "w-7/12 bg-white h-full"
  }, [_c('div', {
    staticClass: "polygon bg-neutral-600 h-full flex items-center flex-col justify-center gap-10"
  }, [_vm._m(0), _c('div', {
    staticClass: "w-full pr-15p"
  }, [_c('carousel', {
    attrs: {
      "options": _vm.carouselBannerOptions,
      "slides": _vm.slides
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn(_ref) {
        var item = _ref.item,
            index = _ref.index;
        return [_c('img', {
          staticClass: "inline-block mb-6",
          attrs: {
            "src": item.image,
            "id": 'image-' + index
          }
        }), _c('p', {
          staticClass: "w-3/5 mx-auto text-white"
        }, [_vm._v(_vm._s(item.description))])];
      }
    }], null, false, 1749293510)
  })], 1)])]) : _vm._e(), _c('div', {
    staticClass: "w-5/12 bg-white relative h-full mdmax:w-full"
  }, [_c('div', {
    staticClass: "px-36 py-20 flex flex-col justify-center h-full mdmax:px-10 mdmax:py-10"
  }, [_vm._m(1), _c('div', {
    staticClass: "form mt-4 text-left"
  }, [_c('div', {
    staticClass: "mb-8"
  }, [_c('TextField', {
    attrs: {
      "type": "password",
      "label": "Password Baru",
      "placeholder": "Silahkan masukan password baru",
      "error": _vm.errors['password']
    },
    on: {
      "enter": function enter($event) {
        return _vm.doReset();
      }
    },
    model: {
      value: _vm.payload.password,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "password", $$v);
      },
      expression: "payload.password"
    }
  })], 1), _c('div', {
    staticClass: "mb-8"
  }, [_c('TextField', {
    attrs: {
      "type": "password",
      "label": "Konfirmasi Password Baru",
      "placeholder": "Silahkan masukan konfirmasi password baru",
      "error": _vm.errors['passwordConfirmation']
    },
    on: {
      "enter": function enter($event) {
        return _vm.doReset();
      }
    },
    model: {
      value: _vm.payload.passwordConfirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "passwordConfirmation", $$v);
      },
      expression: "payload.passwordConfirmation"
    }
  })], 1), _c('div', {
    staticClass: "login__form-submit"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.generalError ? _c('div', {
    staticClass: "text-system-error mb-4"
  }, [_vm._v(_vm._s(_vm.generalError))]) : _vm._e()]), _c('Button', {
    attrs: {
      "buttonText": "Reset",
      "size": "full"
    },
    on: {
      "action": function action($event) {
        return _vm.doReset();
      }
    }
  })], 1)])])]), _c('Toast')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-center items-center pr-15p"
  }, [_c('img', {
    staticClass: "w-56",
    attrs: {
      "src": require("@/assets/images/logos/Logo-linknau-new.svg")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "inline-block",
    attrs: {
      "src": require("@/assets/images/logos/linknau-logo.svg")
    }
  }), _c('p', {
    staticClass: "font-bold text-2xl mt-10 mb-2 mdmax:mt-20"
  }, [_vm._v("Reset Password")]), _c('p', {
    staticClass: "text-sm mb-14 text-neutral-500"
  }, [_vm._v("Silahkan ubah password kamu, dengan password yang diinginkan.")])]);
}]

export { render, staticRenderFns }